import type { RightyMessage, RightyToolCall } from '../types'

const MUTATING_TOOL_PREFIXES = ['create_', 'update_', 'delete_', 'move_']

const MUTATING_TOOL_NAMES = new Set([
  'bootstrap_flow',
  'configure_sync',
  'end_split_test',
  'install_template',
  'manage_flow_split',
  'modify_flow',
  'start_split_test',
  'undo_last_change'
])

export function isConfigMutatingToolCall(toolCall: Pick<RightyToolCall, 'name'> | null | undefined): boolean {
  const name = toolCall?.name
  if (!name) return false

  return MUTATING_TOOL_PREFIXES.some((prefix) => name.startsWith(prefix))
    || MUTATING_TOOL_NAMES.has(name)
}

export function assistantMessageAppliedConfigMutation(message: RightyMessage | null | undefined): boolean {
  if (message?.role !== 'assistant') return false

  if (message.metadata?.configMutated === true) {
    return true
  }

  if ((message.metadata?.planApplied?.changelog?.length ?? 0) > 0) {
    return true
  }

  // Backward-compat fallback for historical messages saved before the backend
  // stamped explicit configMutated metadata.
  return (message.metadata?.tool_calls ?? []).some(isConfigMutatingToolCall)
}
